"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
const react_1 = require("react");
const useIsomorphicLayoutEffect_1 = require("./useIsomorphicLayoutEffect");
/*
Hepler hook to track element size using ResizeObserver API
Args:
  callback - Event emitted each time elements changes size
Returns:
  ref - Ref to tracked element
  disconnectObserver - Function to stop observer manually
*/
const useResizeObserver = (callback) => {
    const ref = (0, react_1.useRef)(null);
    const observer = (0, react_1.useRef)(null);
    const disconnectObserver = (0, react_1.useCallback)(() => {
        var _a;
        (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
    }, []);
    (0, useIsomorphicLayoutEffect_1.useIsomorphicLayoutEffect)(() => {
        const element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (ResizeObserver && element) {
            observer.current = new ResizeObserver((entries) => {
                callback(element, entries[0]);
            });
            observer.current.observe(element);
        }
        return () => {
            disconnectObserver();
        };
    }, [callback, ref, disconnectObserver]);
    return [ref, disconnectObserver];
};
exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map